module.exports = __webpack_public_path__ + "img/domain14-icon-5.b004d2a2.webp";